import React from "react"
import Text from "@amzn/meridian/text";
import {FormattedMessage} from "react-intl";
import Column from "@amzn/meridian/column";
import Box from "@amzn/meridian/box";
import Tooltip from "@amzn/meridian/tooltip";
import {useDeviceLayout} from "../common/context/DeviceLayoutContext";

const PickStatusViewV2 = (props) => {
    const {headerFont, textFont} = useDeviceLayout()

    const getHeader = () => {
        return <Text type={headerFont}>
            <b><FormattedMessage id={props.data.headerId} defaultMessage={props.data.defaultHeader} /></b>
        </Text>
    }

    return (
        <Box type="outline" spacingInset={"medium"}>
            <Column spacingInset={"none"}>
                {props.data.displayTooltip ?
                    <Tooltip position={"top"} title={props.data.tooltipText}>
                        {getHeader()}
                    </Tooltip>
                    : getHeader()
                }
                <Column spacing="none">
                    <Text type="d50">{props.data.value}</Text>
                    <Text type={textFont} color={"secondary"}>
                        <FormattedMessage id={props.data.footerId} defaultMessage={props.data.defaultFooter} />
                    </Text>
                </Column>
            </Column>
        </Box>
    )
}

export default PickStatusViewV2


// WEBPACK FOOTER //
// ./src/components/pickStatus/PickStatusV2.js